import { IAppContext } from "../contexts/AppContext";

class AppClient implements IAppContext {
  toggleThemeMode: IAppContext["toggleThemeMode"];
  currentTheme: IAppContext["currentTheme"];
  mintRate: IAppContext["mintRate"];

  constructor(
    themeMode: IAppContext["toggleThemeMode"],
    currentTheme: IAppContext["currentTheme"],
    mintRate: IAppContext["mintRate"]
  ) {
    this.toggleThemeMode = themeMode;
    this.currentTheme = currentTheme;
    this.mintRate = mintRate;
  }
}

export default AppClient;
